import { DisplayCategoryFragment, ExternalOfferFragment } from '@ocx/graphql';

import type { Offer } from '../offer.types';
import type { OffersCarouselCategory } from './offers-carousel-category.types';

const getOffersForCategory = (offers: Offer[], categoryId: string) => {
  return offers.filter((offer) => offer.displayCategories.some((offerCategory) => offerCategory.id === categoryId));
};

const getFlattenBannersForBannerIds = (banners: ExternalOfferFragment[], bannerIds?: string[] | null) => {
  if (!bannerIds) {
    return [];
  }
  return bannerIds.reduce<ExternalOfferFragment[]>(
    (result, current) => [
      ...result,
      ...banners.filter(({ bannerConfigurationUuid }) => bannerConfigurationUuid === current),
    ],
    [],
  );
};

export const groupOfferAndCategories = (
  categories: DisplayCategoryFragment[] = [],
  offers: Offer[] = [],
  banners: ExternalOfferFragment[] = [],
): OffersCarouselCategory[] => {
  return categories.reduce<OffersCarouselCategory[]>((result, category) => {
    const categoryOffers = getOffersForCategory(offers, category.id);
    const shouldLazyLoadBanners = !!category.shouldLazyLoadBanners;
    // Lazy categories keep empty banners here; selected-category hook fills them on navigate.
    const categoryBanners = shouldLazyLoadBanners ? [] : getFlattenBannersForBannerIds(banners, category.bannerIds);

    if (!categoryOffers.length && !categoryBanners.length && !shouldLazyLoadBanners) {
      // We do not show empty eager categories
      return result;
    }

    return [
      ...result,
      {
        id: category.id,
        title: category.name,
        offers: categoryOffers,
        banners: categoryBanners,
        bannerIds: category.bannerIds,
        shouldLazyLoadBanners,
      },
    ];
  }, []);
};
